import { Fragment, lazy } from "react";
import { Route } from "react-router-dom";

import { routes } from "@/config/routes";

const ProposalView = lazy(() => import("@/pages/ProposalView"));
const ProposalInternalSign = lazy(() => import("@/pages/ProposalInternalSign"));
const ProposalPrintView = lazy(() => import("@/pages/ProposalView/PrintView"));
const WorkOrderView = lazy(() => import("@/pages/WorkOrderView"));
const PaymentLink = lazy(() => import("@/pages/ec/PaymentLink"));
const PublicCompliance = lazy(() => import("@/pages/PublicCompliance"));
const InsuranceRequirements = lazy(() => import("@/pages/PublicCompliance/Requirements"));
const PublicCoi = lazy(() => import("@/pages/PublicCoi"));
const CustomerFeedbackSurvey = lazy(() => import("@/pages/CustomerFeedback/Survey"));
const InstallerAccessPage = lazy(() => import("@/pages/InstallerAccess"));

// Public token routes share one mount point so they render for ANY auth state
// (unauthenticated, partner/internal, or END_CUSTOMER). Mounting only inside
// the partner-side `appRoutes` previously caused authenticated end customers
// to see a blank page on /proposal/:token, /work-order/:token, /pay/:token.
const PublicTokenRoutes = (
  <Fragment>
    <Route path="/feedback" element={<CustomerFeedbackSurvey />} />
    <Route path={routes.proposal.view} element={<ProposalView />} />
    {/* Internal countersignature link: same click-and-proceed surface as the
        customer link, but for the Swiftlane party. */}
    <Route path={routes.proposal.internalSign} element={<ProposalInternalSign />} />
    {/* What headless Chromium prints for the proposal PDF (spec §11). */}
    <Route path="/proposal/print/:printToken" element={<ProposalPrintView />} />
    <Route path={routes.workOrder.view} element={<WorkOrderView />} />
    <Route path="/pay/:token" element={<PaymentLink />} />
    <Route path={routes.installerCompliancePublic.upload} element={<PublicCompliance />} />
    <Route path={routes.installerCompliancePublic.requirements} element={<InsuranceRequirements />} />
    <Route path={routes.coiPublic.request} element={<PublicCoi />} />
    <Route path={routes.installerAccess.view} element={<InstallerAccessPage />} />
  </Fragment>
);

export default PublicTokenRoutes;
